module.exports = __webpack_public_path__ + "static/media/PROFILE_WAITING_FOR_MIRACLE.909fcedb.md";